"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var YearStartInput_vue_1 = __importDefault(require("../form/YearStartInput.vue"));
var YearEndInput_vue_1 = __importDefault(require("../form/YearEndInput.vue"));
var LastChargeDayInput_vue_1 = __importDefault(require("../form/LastChargeDayInput.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var request_1 = __importDefault(require("../../request"));
var store_1 = require("../../store");
var __ = window.$lang;
var ContributionsSettings = /** @class */ (function (_super) {
    __extends(ContributionsSettings, _super);
    function ContributionsSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "contributions-settings";
        _this.yearStart = (new Date()).getFullYear();
        _this.yearEnd = (new Date()).getFullYear();
        _this.lastChargeDay = 1;
        return _this;
    }
    ContributionsSettings.prototype.created = function () {
        this.yearStart = this.$store.state.settings.CONTRIBUTIONS_YEAR_START;
    };
    ContributionsSettings.prototype.isYearStartValid = function () {
        return (!isNaN(this.yearStart) &&
            this.yearStart >= 2014 &&
            this.yearStart <= this.yearEnd);
    };
    ContributionsSettings.prototype.isYearEndValid = function () {
        return (!isNaN(this.yearEnd) &&
            this.yearEnd <= (new Date()).getFullYear() + 1 &&
            this.yearEnd >= this.yearStart);
    };
    ContributionsSettings.prototype.isLastChargeDayValid = function () {
        return (this.lastChargeDay >= 1 &&
            this.lastChargeDay <= 31);
    };
    ContributionsSettings.prototype.isFormValid = function () {
        return (this.isYearStartValid() &&
            this.isYearEndValid() &&
            this.isLastChargeDayValid());
    };
    ContributionsSettings.prototype.submitForm = function () {
        var _this = this;
        if (!this.isFormValid()) {
            return;
        }
        request_1.default.setting.update({
            CONTRIBUTIONS_YEAR_START: this.yearStart,
            CONTRIBUTIONS_YEAR_END: this.yearEnd,
            CONTRIBUTIONS_LAST_CHARGE_DAY: this.lastChargeDay
        }, function (settings) {
            _this.$notification("success", __("Ustawienia zostały zapisane."));
            _this.$store.dispatch(store_1.Action.updateSettings, {
                settings: settings
            });
        });
    };
    ContributionsSettings.prototype.onKeyDown = function (keyCode) {
        if (keyCode === 13) {
            this.submitForm();
        }
    };
    ContributionsSettings = __decorate([
        vue_class_component_1.default({ components: {
                LastChargeDayInput: LastChargeDayInput_vue_1.default,
                VButton: VButton_vue_1.default,
                YearEndInput: YearEndInput_vue_1.default,
                YearStartInput: YearStartInput_vue_1.default
            } })
    ], ContributionsSettings);
    return ContributionsSettings;
}(vue_property_decorator_1.Vue));
exports.default = ContributionsSettings;
